
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService, HttpOptions } from '@core/services/api/api.service';
import { IVisitDocumentPage } from '@precheckin/models/visit-document/visit-document-page.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisitDocumentPagesService {
  private readonly endpoint = `pre-checkin/documents`;

  constructor(
    private apiService: ApiService,
    protected httpClient: HttpClient
  ) { }

  public delete(
    visitDocumentId: string,
    visitDocumentPageId: string
  ): Observable<void> {
    return this.apiService.delete(
      `${this.endpoint}/${visitDocumentId}/pages/${visitDocumentPageId}/delete`
    );
  }

  public download(
    visitDocumentId: string,
    visitDocumentPageId: string
  ): Observable<Blob> {
    const options: HttpOptions = {
      responseType: 'blob'
    };

    return this.apiService.get<Blob>(
      `${this.endpoint}/${visitDocumentId}/pages/${visitDocumentPageId}/download`,
      options
    );
  }

  public upload(
    documentId: string,
    documentPageType: string,
    file: File
  ): Observable<IVisitDocumentPage> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mediaType', file.type);
    if (documentPageType) {
      formData.append('type', documentPageType);
    }

    return this.apiService.post<IVisitDocumentPage>(
      `${this.endpoint}/${documentId}/pages`,
      formData
    ) as Observable<IVisitDocumentPage>;
  }
}
